import React, { useState } from 'react';
import axios from 'axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, TextField, Button, Typography, Alert,
  Stack, InputAdornment, IconButton, Link, CircularProgress,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../provider/authProvider';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setToken, setAdminApiToken } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setLoginError(false);
    setLoading(true);
    try {
      const res = await axios.post(
        'https://portal.peaksoftcon.com:8081/login',
        { username, password },
      );
      if (res.data === 'No Record') {
        setLoginError(true);
        return;
      }
      localStorage.setItem('companyInfo', JSON.stringify({
        ID: res.data.companyID,
        name: res.data.companyName,
        fullname: res.data.companyFullName,
        mail: res.data.companyMail,
        address: res.data.companyAddress,
        phone: res.data.companyPhone,
        role: res.data.companyRole,
        serviceID: res.data.companyServiceID,
      }));
      setAdminApiToken(res.data.adminApiToken || null);
      setToken('logged-in');
      navigate('/', { replace: true });
    } catch (err) {
      console.error(err);
      setLoginError(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (t) =>
          t.palette.mode === 'dark'
            ? 'linear-gradient(135deg, #0B1220 0%, #1E3A8A 100%)'
            : 'linear-gradient(135deg, #1E3A8A 0%, #3B5BC9 100%)',
        p: 2,
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 420,
          boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
            <Box
              component="img"
              src="/img/Peak_Logo_Kobalt.png"
              alt="Peak"
              sx={{ width: 96, height: 'auto' }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>Peak Portal</Typography>
            <Typography variant="body2" color="text.secondary">
              Hesabınla devam et
            </Typography>
          </Stack>

          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="Kullanıcı adı"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
                required
                autoComplete="username"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Şifre"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                required
                autoComplete="current-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((s) => !s)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {loginError && (
                <Alert severity="error">
                  Kullanıcı adı veya şifre hatalı.
                </Alert>
              )}
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={loading}
                sx={{ py: 1.25 }}
              >
                {loading ? <CircularProgress size={22} color="inherit" /> : 'Giriş Yap'}
              </Button>
            </Stack>
          </form>

          <Box sx={{ textAlign: 'center', mt: 2.5 }}>
            <Link component={RouterLink} to="/forgotPassword" underline="hover">
              Şifremi unuttum
            </Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default LoginPage;
